import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";

export default function Documents({ tenantData }) {
  const [data, setData] = useState(tenantData || {});

  useEffect(() => {
    setData(tenantData || {});
  }, [tenantData]);

  // console.log("tenantData", tenantData);

  return (
    <Wrapper>
      <Title>Documents</Title>
      <hr />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
        {[
          { label: "Aadhar Card", key: 1 },
          { label: "Pan Card", key: 3 },
          { label: "Student/Employer Id", key: 7 },
          { label: "Police Verification", key: 6 },
          { label: "Rent Agreement", key: 5 },
          { label: "Other Documents", key: 4 },
        ].map((item) => {
          const uploadedDoc = data?.type === item.key ? data : null;

          return (
            <div
              key={item.key}
              className="flex flex-col items-start bg-gray-100 p-4 rounded-lg shadow"
            >
              <span className="block text-sm font-medium text-blue-600 mb-2">
                {item.label}
              </span>

              {uploadedDoc ? (
                <a
                  href={uploadedDoc.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 mb-4 underline hover:text-blue-800"
                >
                  View/Download File
                </a>
              ) : (
                <p className="text-sm text-gray-500 mb-4">
                  No document uploaded
                </p>
              )}

              <label
                htmlFor={`upload-${item.key}`}
                className="text-sm text-gray-800 cursor-pointer hover:underline"
              >
                Upload File
              </label>
              <input
                id={`upload-${item.key}`}
                type="file"
                className="hidden"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const fileUrl = URL.createObjectURL(file);
                    setData({
                      ...data,
                      type: item.key,
                      value: fileUrl, 
                    });
                  }
                }}
              />
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
}

const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
